import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceListComponent } from './marketplace-list.component';
import { SortBarModule } from '@fgb/portal-component-library/src/lib/shared/sort-bar';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { MarketplaceListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FilterStatusModalModule } from './filter-status-modal';
import { InlineSVGModule } from 'ng-inline-svg-2';

@NgModule({
  declarations: [MarketplaceListComponent],
  imports: [
    CommonModule,
    SortBarModule,
    LoadingModule,
    MarketplaceListItemModule,
    DirectivesModule,
    FGBSharedModule,
    FilterStatusModalModule,
    InlineSVGModule.forRoot(),
  ],
  exports: [MarketplaceListComponent],
})
export class MarketplaceListModule {}
